import clsx from "clsx";
import React from "react";
import { LayoutWidth, MediaSpecific, widthClass } from "../Layout";
import { PageContent, PageContentProps } from "../Page";
import css from "./captioned-image.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";

export interface CaptionedImageLayout extends LayoutWidth { }

export interface CaptionProps extends PageContentProps {
    hiddenOnMobile?: boolean;
}

export interface CaptionedImageProps extends React.ComponentProps<"figure">
{
    captionProps?: CaptionProps;
    footer?: React.ReactNode;
    imageProps: React.ComponentProps<typeof VadImage>;
    layout?: MediaSpecific<CaptionedImageLayout>;
    leftAligned?: boolean; // TODO: refactor to use layout instead
    captionClassName?: string;
    width?: number;
}

export const CaptionedImage = ({ captionProps, children, className, footer, imageProps, layout, leftAligned, width, ...props }: CaptionedImageProps): React.ReactComponentElement<"figure", CaptionedImageProps> =>
{
    const classes = clsx(
        css["captioned_image"],
        {
            [css["captioned_image--centered"]]: !leftAligned,
        },

        widthClass(layout),
        className
    );

    const captionClasses = clsx(
        {
            [css["captioned_image--hidden-on-mobile"]]: captionProps?.hiddenOnMobile,
        },
        captionProps?.className,
    );

    const captionContent = children !== undefined ? children : captionProps !== undefined ? <PageContent {...captionProps} className={captionClasses} /> : undefined;

    return (
        <figure {...props} className={`${width != undefined ? css[`figure_width-${width}`] : ""} ${classes}`}>
            <VadImage {...imageProps} />
            {
                captionContent !== undefined &&
                <figcaption>
                    {captionContent}
                    {footer}
                </figcaption>
            }
        </figure>
    );
}
